import styled from 'styled-components'

export const TitlePageContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const MainContainer = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const CardContainer = styled.div`
  & > div:nth-child(1) {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
`

export const PaginationContainer = styled.div`
  margin-top: ${props => props.theme.spacing.sp24};
  padding-top: ${props => props.theme.spacing.sp24};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ProductsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
